import { JsonPipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { LoginService } from '../service/login.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private cookieService: CookieService, private loginService: LoginService) { }
   login: string='';
  // createCookie(email:any, key:string) {
  //   const dateNow = new Date();
  //   dateNow.setMinutes(dateNow.getMinutes() + 30);
  //   // this.login=email;
  //   // this.cookieService.set(email, key, dateNow);
  //   sessionStorage.setItem('user', email);
  //   sessionStorage.setItem('key', key);

  // }
  createCookie(email:any, key:string) {
    const dateNow = new Date();
    dateNow.setMinutes(dateNow.getFullYear() + 10);
    this.login=email;
    this.cookieService.set('usr', key, dateNow);
    this.cookieService.set('usuario', email, dateNow);

  }

  // checkExistCookie() {

  //   const user = <any>sessionStorage.getItem('user');
  //   const key = <any>sessionStorage.getItem('key');
  //   let bool =false;
  //   console.log("usr " +user+' key '+ key);

  //     return this.loginService.checkSesion(key).subscribe((data:string)=>{
  //       if(data='1'){
  //         console.log("esta bien " +user);
  //         bool= true;

  //       }else{
  //         console.log("No existe en el back " +user);

  //       }
  //       return bool;
  //     });

  // }
  async checkExistCookie():Promise<boolean> {

    // const user = <any>sessionStorage.getItem('user');
    // const key = <any>sessionStorage.getItem('key');
    let bool =false;
    // console.log("usr " +user+' key '+ key);
    // this.cookieService.getAll()

      await this.loginService.checkSesion(this.cookieService.get('usr')).then((data)=>{

        if(data=="1"){
           console.log(data +"esta bien "+this.cookieService.get('usr'));
           bool= true;

        }else{
           console.log("No existe en el back " );
           this.cookieService.delete('usr');
          this.cookieService.delete('usuario');
           window.location.href = "/";
           bool= false;
        }

      }).catch((reason)=>{bool= false});

    return bool;
  }

  getCookie() {
    return this.cookieService.get('usr');
    // return <any>sessionStorage.getItem('key');
  }
  getUsr() {
    return this.cookieService.get('usuario');
    // return <any>sessionStorage.getItem('key');
  }


  setMoreTime() {
    // if (this.checkExistCookie()) {
    //   const dateNow = new Date();
    //   dateNow.setMinutes(dateNow.getMinutes() + 1);
    //   this.cookieService.set(this.login, this.cookieService.get(this.login), dateNow);
    // }
  }

  deleteCookie(){
    // sessionStorage.clear();
    this.cookieService.delete('usr');
    this.cookieService.delete('usuario');
  }

}
